/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicParseNetworkDetails extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicParseNetworkDetails");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicParseNetworkDetails.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicParseNetworkDetails>): BackgroundJobPayloadForPeriodicParseNetworkDetails {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicParseNetworkDetails(), model);
        BackgroundJobPayloadForPeriodicParseNetworkDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicParseNetworkDetails>): BackgroundJobPayloadForPeriodicParseNetworkDetails {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicParseNetworkDetails.newInstance(<BackgroundJobPayloadForPeriodicParseNetworkDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicParseNetworkDetails) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicParseNetworkDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicParseNetworkDetails): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicParseNetworkDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
